export const currentPage = {
    '/restaurants' : 'Restaurants',
    '/activities' : 'Activités',
    '/beauty' : 'Bien-être & Spa',
    '/cars' : 'Services auto',
    '/alimentation' : 'Epiceries',
    '/about' : 'À propos',

    '/login' : 'Connexion',
    '/register' : 'Inscription',

    '/trader' : 'Mon Espace',
    '/trader/profil' : 'Profile',
    '/trader/offers' : 'Mes Offres',
    '/trader/pass' : 'Mon Abonnement',

    '/admin' : 'Mon Espace',
    '/admin/profil' : 'Profile',
    '/admin/control' : 'Manager',

    '/client/pass' : 'Mon Abonnement',
    '/client/profil' : 'Profile',

    'Merchant' : "Commerçant",
};